import AlvDividendsTableBlock from 'components/AlvDividendsTableBlock';
import AlvStockPriceTeaser from 'components/AlvStockPriceTeaser';
import AlvStockGraphBlock from 'components/AlvStockGraphBlock';
import AlvStockExchangeAnnouncement from 'components/AlvStockExchangeAnnouncement';
import AlvStockExchangeAnnouncementPreview from 'components/AlvStockExchangeAnnouncementPreview';
import AlvStockExchangeAnnouncementBlock from 'components/AlvStockExchangeAnnouncementBlock';
import AlvKeyFiguresBlock from 'components/AlvKeyFiguresBlock';
import AlvStockPriceAndCompanyInfoBlock from 'components/AlvStockPriceAndCompanyInfoBlock';
import AlvShareBuybacksTableBlock from 'components/AlvShareBuybacksTableBlock';
import AlvKeyFiguresTableBlock from 'components/AlvKeyFiguresTableBlock';
import AlvTopShareholdersTableBlock from 'components/AlvTopShareholdersTableBlock';

module.exports = {
    AlvDividendsTableBlock,
    AlvStockPriceTeaser,
    AlvStockGraphBlock,
    AlvStockExchangeAnnouncement,
    AlvStockExchangeAnnouncementPreview,
    AlvStockExchangeAnnouncementBlock,
    AlvKeyFiguresBlock,
    AlvStockPriceAndCompanyInfoBlock,
    AlvShareBuybacksTableBlock,
    AlvKeyFiguresTableBlock,
    AlvTopShareholdersTableBlock
};



// WEBPACK FOOTER //
// ./src/alvComponents.js